import React from 'react'
import TimelineSummaryDetail from './TimelineSummaryDetail'
import ItemView from '../../leave_plan_benefits/shared/ItemView'
import TasksHelper from '../../support/TasksHelper.js'

class ScheduleTimelineView extends React.Component{
  constructor(props) {
    super(props)
    this.state =  {
      allowFetchData: !props.lastEventIncluded
    };
  }

  displaySpinner() {
    const opt = {
      length: 2,
      lines: 8,
      radius: 6
    };
    const spinner = new Spinner(opt).spin();
    $('.load-more-data').append(spinner.el);
  }

  manageTimelineData(date, data) {
    return this.props.manageTimelineData(date, data);
  }
  handleScroll() {
    const div = $('#timeline-tab');
    const divHeight = div.height();
    const winHeight = $(window).height();
    const scrollTop = $(window).scrollTop();
    if (Math.abs((winHeight + scrollTop) - divHeight) < 200) {
      if (this.state.allowFetchData && !this.props.lastEventIncluded) {
        const next_date = moment(this.props.requested_date).add(1, 'months').format("YYYY-MMMM-DD");
        this.setState({allowFetchData: false});
        this.displaySpinner();
        $.getJSON("/schedules/build_events", {eventable: 'timeline', input_date_for_timeline_view: next_date}, data => {
          this.setState({allowFetchData: true});
          this.props.onScrollToBottom(data);
      }).done(() => $('.spinner').remove());
      }
    }
  }

  hasItem(data) {
    return TasksHelper._countTaskItems(this.props.show_hidden_tasks, data.timeline_events.uncompleted_items, data.timeline_events.completed_items, this.props.show_essential_tasks, this.props.show_recommended_tasks, this.props.show_information_only_tasks) > 0;
  }

  scrollingDate() {
    if (this.props.summary_date) {
      return moment(this.props.summary_date).format("YYYY-MM-DD");
    } else if (moment(this.props.data[0].date) >= moment()) {
      return moment(this.props.data[0].date).format("YYYY-MM-DD");
    } else {
      return moment().format("YYYY-MM-DD");
    }
  }

  grepDataWithDate(scroll_to_date) {
    return $.grep(this.props.data, d => scroll_to_date === d.date)[0];
  }

  lastData() {
    return this.props.data[this.props.data.length - 1];
  }

  findDataWithItems(focusingData) {
    let index = this.props.data.indexOf(focusingData);
    let found = false;
    if (this.hasItem(focusingData.data)) {
      found = true;
    } else {
      while (!found && (index > 0)) {
        index -= 1;
        if (this.hasItem(this.props.data[index].data)) { found = true; }
      }
    }
    return {index, found};
  }

  focusingElement() {
    const { data } = this.props;
    if (data.length > 0) {
      const scroll_to_date = this.scrollingDate();
      let focusingData = this.grepDataWithDate(scroll_to_date);
      if (!focusingData) {
        focusingData = this.lastData();
      }
      focusingData = this.findDataWithItems(focusingData);
      if (focusingData.found) {
        return $.grep($('.timeline-summary-detail'), t => $(t).attr('data-date') === data[focusingData.index].date)
      } else {
        return false;
      }
    }
  }

  taskId() {
    return $.getUrlVars(location.search).task;
  }

  handleBack(state) {
    window.history.pushState( state, state.taskItem.name, this.taskHashId(state.taskItem) );
    return window.onpopstate = (() => {
      ({ state } = history);
      if (location.search) {
        return this.props.handleItemClick(state.itemType, state.taskItem.item_id, state.description, state.imageUrl, state.association);
      } else {
        return this.props.handleItemClick('', '', '', '');
      }
    });
  }

  handleBackClick() {
    history.back();
  }

  setActiveClass(itemType, itemId, description, imageUrl, association, lookUpField, itemFiles) {
    const taskItem = this.selectedItem(itemId);
    if (taskItem) {
      if (window.location.search.substring(1) !== this.taskHashId(taskItem).substring(1)) {
        this.handleBack({itemType, taskItem, description, imageUrl, association});
      }
      $(window).scrollTop(0);
      return this.props.handleItemClick(itemType, itemId, description, imageUrl, association, lookUpField, itemFiles);
    }
  }

  taskHashId(taskItem) {
    if (taskItem.custom_task) {
      return `?task=customTask-${taskItem.timeline_id}`;
    } else {
      return `?task=taskItem-${taskItem.leave_item_id}`;
    }
  }

  componentDidMount() {
    if (!this.viewMode()) {
      let focusingElement;
      if (focusingElement = this.focusingElement()) {
        $(window).scrollTop($(focusingElement).offset().top - 80);
      }
    }

    if (this.taskId()) {
      let lookUpField;
      const hashString = this.taskId();
      const itemType = hashString.split('-')[0];
      const itemId = hashString.split('-')[1];
      if (itemType === 'taskItem') { lookUpField = 'leave_item_id'; }
      const taskItem = this.selectedItem(itemId, lookUpField);
      window.history.replaceState({}, 'LeaveLogic', '/schedules');
      if (taskItem) {
        $.getJSON(`/timeline_items/${taskItem.timeline_id}/fetch_details`, (data) => {
          gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
          this.setActiveClass('timeline_event', taskItem.id, data.description, data.image_url, data.association, null, data.item_files);
        });
      }
    }
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  viewMode() {
    return (this.props.display_modal.item_type === 'timeline_event') && this.selectedItem();
  }

  selectedItem(displayItemId = null, lookUpField) {
    if (lookUpField == null) { lookUpField = 'id'; }
    if (!displayItemId) { displayItemId = this.props.display_modal.item_id; }
    return this.props.data.map(dayData => dayData.data.timeline_events.completed_items.concat(dayData.data.timeline_events.uncompleted_items)).flatten().filter(data => Number(data[lookUpField]) === Number(displayItemId))[0];
  }

  itemForViewMode() {
    const taskItem = this.selectedItem();
    taskItem['image_url'] = this.props.display_modal.image_url;
    taskItem['item_type'] = 'timeline_items';
    taskItem['item'] = {
      timeline_id: taskItem.timeline_id,
      helpful: taskItem.helpful
    }
    return taskItem;
  }

  onHelpfulCheckFromOutside(data) {
    return this.props.onHelpfulCheck(this.selectedItem().date, data);
  }

  sortByName(a, b) {
    return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())
  }

  sortByEventType(a, b){
    let sortOrder = ["Essential", "Recommended", "Information Only"]
    return sortOrder.indexOf(a.event_type) - sortOrder.indexOf(b.event_type)
  }

  sortByDate(a, b) {
    return moment(a.date).toDate() - moment(b.date).toDate()
  }

  sortData(data) {
    data.forEach(timelineData => {
      timelineData.data.timeline_events.uncompleted_items.sort((a,b) => {
        return this.sortByEventType(a, b) || this.sortByDate(a, b) || this.sortByName(a, b)
      })
      timelineData.data.timeline_events.completed_items.sort((a, b) => {
        return this.sortByEventType(a, b) || this.sortByDate(a, b) || this.sortByName(a, b)
      })
    })
    return data
  }

  render() {
    if(this.viewMode()) {
      return(
        <ItemView
          data={this.itemForViewMode()}
          description={this.props.display_modal.description}
          just_looking={this.props.just_looking}
          handleJustLookingClick={this.props.handleJustLookingClick}
          onHelpfulCheckFromOutside={this.onHelpfulCheckFromOutside.bind(this)}
          handleBackClick={this.handleBackClick.bind(this)}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
          itemFiles={this.props.display_modal.itemFiles}
        />
      )
    } else {
      let timelineSummaryDetail = []
      this.sortData(this.props.data).map((day_data) => {
        timelineSummaryDetail.push(
          <TimelineSummaryDetail
            date={day_data.date}
            timeline_events={day_data.data.timeline_events}
            title={day_data.title}
            key={this.props.data.indexOf(day_data)}
            manageTimelineData={this.manageTimelineData.bind(this)}
            handleItemClick={this.setActiveClass.bind(this)}
            display_modal={this.props.display_modal}
            onHelpfulCheck={this.props.onHelpfulCheck}
            handleJustLookingClick={this.props.handleJustLookingClick}
            show_hidden_tasks={this.props.show_hidden_tasks}
            handleCustomTaskDelete={this.props.handleCustomTaskDelete}
            handleCustomTaskChange={this.props.handleCustomTaskChange}
            handleCustomTaskClick={this.props.handleCustomTaskClick}
            custom_task_modal={this.props.custom_task_modal}
            show_essential_tasks={this.props.show_essential_tasks}
            show_recommended_tasks={this.props.show_recommended_tasks}
            show_information_only_tasks={this.props.show_information_only_tasks}
            isLeavePlanPartner={this.props.isLeavePlanPartner}
            disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
          />
        )
      })
      return (
        <div id='timeline-tab'>
          { timelineSummaryDetail }
          <div className='load-more-data'/>
        </div>
      )
    }
  }
}

export default ScheduleTimelineView
